import { render, staticRenderFns } from "./EmitirCertificado.vue?vue&type=template&id=079c1cea&"
import script from "./EmitirCertificado.vue?vue&type=script&lang=ts&"
export * from "./EmitirCertificado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('079c1cea', component.options)
    } else {
      api.reload('079c1cea', component.options)
    }
    module.hot.accept("./EmitirCertificado.vue?vue&type=template&id=079c1cea&", function () {
      api.rerender('079c1cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/EmitirCertificado.vue"
export default component.exports